import React from 'react'
import SingleRun from './SingleRun'
import { durationCalculate,runTypePick,calculateActivitySpeed,distanceEstimation} from '../../helperFunctions/runningProgramFunctions';


function WeekProgram({week,measurementSystem}){
    //console.log(week)
    const user = JSON.parse(localStorage.getItem('user')) 
    const [runType,tss_activity] = runTypePick(week.weekType,week.program_runs_per_week)
    var activities = []
    for(var i=1;i<=week.program_runs_per_week;i++){
        var tss = tss_activity[i-1]*week.stressScoreTarget
        var duration = durationCalculate(tss,runType[i-1],user)
        var speed = calculateActivitySpeed(duration,runType[i-1],user)
        var est_distance = distanceEstimation (duration,speed)
        activities.push({type:runType[i-1],duration,speed,est_distance,est_distance,tss,user})   
    }
    return(
        <>
            <tbody>
                <td style={{backgroundColor:'#444444'}}>
                    <h5 class="text-warning">Week   - <span class="text-info"> {week.id}</span></h5>      
                </td>
                <td class="text-white" style={{backgroundColor:'#444444'}}>
                    <p class="text-info" style={{fonSize:'15px'}}>Starts at <span class="text-warning">{week.weekDurations[week.id-1]}</span> </p> 
                </td>
                <td class="text-info" style={{backgroundColor:'#444444'}}>
                    --
                </td>
                <td class="text-info" style={{backgroundColor:'#444444'}}>
                    {week.stressScoreTarget.toFixed(0)}
                </td>
                
            
                
            </tbody>
            
            {activities.map(activity => <SingleRun measurementSystem={measurementSystem} user={user} activity={activity}/>)}
            
            
        </>
    )
}
    
 

export default WeekProgram